/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery } from '@apollo/client';
import { WarningIcon } from '@chakra-ui/icons';
import { Alert, AlertDescription, Box, Button, Flex, Text } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import c from '../constant';

const Q_PROPOSALS = gql`
	query get {
		getUrgentAndUnreadCompanySubmissionProposals {
			id
			no
			companyName
			subject
			createdAt
			read
			assignTo {
				read
				user {
					id
				}
			}
			approved
			approvedAt
			dueDate
			publicService
			spam
			company {
				id
				name
				nameKhmer
				logo
			}
			done
			doneAt
			submissionStatus
			startServiceDate
			assignedDepartment {
				id
			}
			assignedOffice {
				id
			}
			urgent
		}
	}
`;

export default function UrgentProposalAlert() {
	const { push } = useHistory();
	const { t } = useTranslation();
	const [getProposals, { data }] = useLazyQuery(Q_PROPOSALS);

	useEffect(getProposals, []);

	return (
		<>
			{data?.getUrgentAndUnreadCompanySubmissionProposals?.map((e, i) => {
				return (
					<Alert key={i} status="warning" variant="left-accent" mt={i === 0 ? 8 : 2}>
						<WarningIcon color="#DD6B20" fontSize="24px" mr={4} />
						<Box w="100%">
							<AlertDescription>
								<Flex alignItems="center" justifyContent="space-between">
									<Flex justifyContent="center" alignItems="center">
										<Box backgroundColor="orange.200" pl={2} pr={2} borderRadius={c.borderRadius}>
											<Text fontSize="md" fontWeight="bold" color="white">
												{e?.no}
											</Text>
										</Box>
										<Text fontSize="md" fontWeight="600" ml={1}>
											{t('Proposal/Letter-In is urgent')}
										</Text>
									</Flex>
									<Button colorScheme="orange" onClick={() => push(`/company-submission-proposal/detail?id=${e?.id}`)}>
										{t('Check')}
									</Button>
								</Flex>
							</AlertDescription>
						</Box>
					</Alert>
				);
			})}
		</>
	);
}
